module.exports = __webpack_public_path__ + "static/media/snapscope-5.c7d04235.jpg";